(function () {
          const trigger = document.getElementById('scroll-btn-trigger');
          const target  = document.getElementById('scroll-btn-target');
          const btn     = document.getElementById('scroll-up-btn');
          if (!trigger || !target || !btn) return;

          const btn_container = document.getElementById('scroll-btn-feature');
          const btn_style = window.getComputedStyle(btn_container);
          let SCROLL_OFFSET = 5;
          if (btn_style.right == '16px') {
            SCROLL_OFFSET = 135;
          }

          const OFFSET = 150;
          
          let visible = false;
          let ticking = false;

          function setVisible(v) {
            if (v === visible) return;
            visible = v;
            btn.classList.toggle('is-visible', v);
          }

          function compute() {
            ticking = false;
            const top = trigger.getBoundingClientRect().top;
            // show once trigger has moved past OFFSET from top
            setVisible(top <= OFFSET);
          }

          // 1) Observer: catches layout changes + most scroll changes
          const io = new IntersectionObserver(() => {
            // Schedule a fresh measurement (don’t trust entry.top)
            if (!ticking) {
              ticking = true;
              requestAnimationFrame(compute);
            }
          }, {
            root: null,
            threshold: 0,
            // Make it "wake up" around where we care
            rootMargin: `-${OFFSET}px 0px 0px 0px`
          });

          io.observe(trigger);

          // 2) Scroll fallback: guarantees recompute on fast up/down flicks
          window.addEventListener('scroll', () => {
            if (!ticking) {
              ticking = true;
              requestAnimationFrame(compute);
            }
          }, { passive: true });

          // Initial state
          compute();

          btn.addEventListener('click', () => {
            //target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            const y = window.scrollY + target.getBoundingClientRect().top - SCROLL_OFFSET;
            window.scrollTo({ top: y, behavior: 'smooth' });
          });

          // 👇 Keyboard-friendly focus fix
          btn.addEventListener('mouseup', function (e) {
            // Mouse click → blur
            // Keyboard activation (Enter/Space) → keep focus
            if (e.detail !== 0) {
              btn.blur();
            }
          });
        })();

 (function () {
  'use strict';

  var pending = null;
  var timer = null;
  var running = false;
  var maxChecks = 5;

  function getSelection(button) {
    var form = button.closest('form[action*="/cart/add"]');

    if (form) {
      var data = new FormData(form);
      var variantId = data.get('id');
      var sellingPlanId = data.get('selling_plan');

      if (variantId && sellingPlanId) {
        return {
          variantId: String(variantId),
          sellingPlanId: String(sellingPlanId)
        };
      }
    }

    var sticky = button.closest('sticky-add-to-cart');

    if (sticky) {
      var variantSelect =
        sticky.querySelector('.sticky-atc__select');

      var variantId =
        (variantSelect && variantSelect.value) ||
        button.dataset.variantId;

      var planInput =
        document.querySelector(
          'input[name="selling_plan"]'
        );

      var subscriptionSelected =
        document.querySelector(
          '.sls-option[data-type="subscription"]:checked'
        ) ||
        document.querySelector(
          '.sls-option-container.sls-active ' +
          '.sls-option[data-type="subscription"]'
        );

      if (
        variantId &&
        subscriptionSelected &&
        planInput &&
        planInput.value
      ) {
        return {
          variantId: String(variantId),
          sellingPlanId: String(planInput.value)
        };
      }
    }

    return null;
  }

  function isAddButton(button) {
    return button && button.matches(
      'button[name="add"],' +
      'button[type="submit"].add-to-cart,' +
      '.add-to-cart-button button[type="submit"],' +
      '.sticky-atc__button'
    );
  }

  function getCartContainer() {
    return (
      document.querySelector(
        '[data-rebuy-cart-anchor="body"]'
      ) ||
      document.querySelector('.rebuy-cart__flyout') ||
      document.querySelector('.rebuy-cart')
    );
  }

  function showLoader() {
    var cart = getCartContainer();

    if (!cart || cart.querySelector('.hp-merge-loader')) {
      return;
    }

    if (!document.getElementById('hp-merge-style')) {
      var style = document.createElement('style');
      style.id = 'hp-merge-style';

      style.textContent =
        '.hp-merge-loader{' +
          'margin:10px 16px;' +
          'padding:12px 14px;' +
          'border:1px solid rgba(42,166,164,.25);' +
          'border-radius:10px;' +
          'background:rgba(42,166,164,.08);' +
          'color:#2aa6a4;' +
          'font-size:14px;' +
          'font-weight:600;' +
          'display:flex;' +
          'align-items:center;' +
          'gap:10px' +
        '}' +
        '.hp-merge-loader:before{' +
          'content:"";' +
          'width:16px;' +
          'height:16px;' +
          'border:2px solid rgba(42,166,164,.25);' +
          'border-top-color:#2aa6a4;' +
          'border-radius:50%;' +
          'animation:hpMergeSpin .7s linear infinite' +
        '}' +
        '@keyframes hpMergeSpin{' +
          'to{transform:rotate(360deg)}' +
        '}';

      document.head.appendChild(style);
    }

    var loader = document.createElement('div');
    loader.className = 'hp-merge-loader';
    loader.textContent =
      'Updating quantity and autoship interval...';

    cart.prepend(loader);
  }

  function hideLoader() {
    document
      .querySelectorAll('.hp-merge-loader')
      .forEach(function (loader) {
        loader.remove();
      });
  }

  async function getCart() {
    var response = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to read cart');
    }

    return response.json();
  }

  function getMatches(cart, selection) {
    return cart.items
      .map(function (item) {
        var allocation =
          item.selling_plan_allocation;

        var plan =
          allocation && allocation.selling_plan;

        return {
          key: item.key,
          quantity: Number(item.quantity) || 0,
          variantId: String(item.variant_id),
          sellingPlanId:
            plan && plan.id ? String(plan.id) : ''
        };
      })
      .filter(function (item) {
        return (
          item.variantId === selection.variantId &&
          item.sellingPlanId
        );
      });
  }

  async function mergeItems(matches, selection) {
    var keepItem = matches.find(function (item) {
      return (
        item.sellingPlanId ===
        selection.sellingPlanId
      );
    });

    if (!keepItem) return false;

    var totalQuantity =
      matches.reduce(function (total, item) {
        return total + item.quantity;
      }, 0);

    var updates = {};

    matches.forEach(function (item) {
      updates[item.key] =
        item.key === keepItem.key
          ? totalQuantity
          : 0;
    });

    showLoader();

    var response = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        updates: updates
      })
    });

    if (!response.ok) {
      throw new Error('Unable to merge items');
    }

    await response.json();

    return true;
  }

  function refreshCart() {
    if (
      window.Rebuy &&
      window.Rebuy.SmartCart
    ) {
      if (
        typeof window.Rebuy.SmartCart.reload ===
        'function'
      ) {
        window.Rebuy.SmartCart.reload();
      } else if (
        typeof window.Rebuy.SmartCart.render ===
        'function'
      ) {
        window.Rebuy.SmartCart.render();
      }

      if (
        typeof window.Rebuy.SmartCart.show ===
        'function'
      ) {
        window.Rebuy.SmartCart.show();
      }
    }

    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true
      })
    );
  }

  async function checkDuplicate(selection, attempt) {
    if (
      running ||
      !pending ||
      pending !== selection
    ) {
      return;
    }

    try {
      var cart = await getCart();
      var matches = getMatches(cart, selection);

      var selectedPlanExists =
        matches.some(function (item) {
          return (
            item.sellingPlanId ===
            selection.sellingPlanId
          );
        });

      if (
        matches.length > 1 &&
        selectedPlanExists
      ) {
        running = true;

        try {
          var merged = await mergeItems(
            matches,
            selection
          );

          if (merged) {
            pending = null;
            refreshCart();

            window.setTimeout(
              hideLoader,
              900
            );
          }
        } finally {
          running = false;
        }

        return;
      }

      if (attempt < maxChecks) {
        timer = window.setTimeout(function () {
          checkDuplicate(
            selection,
            attempt + 1
          );
        }, 500);
      } else {
        pending = null;
      }
    } catch (error) {
      pending = null;
      running = false;
      hideLoader();
    }
  }

  function scheduleCheck(selection) {
    window.clearTimeout(timer);

    pending = selection;

    timer = window.setTimeout(function () {
      checkDuplicate(selection, 1);
    }, 650);
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest(
        'button, input[type="submit"]'
      );

      if (!isAddButton(button)) return;

      var selection = getSelection(button);

      /*
        No selling plan means it is a one-time purchase,
        so no merge check runs.
      */
      if (!selection) {
        pending = null;
        return;
      }

      scheduleCheck(selection);
    },
    true
  );

  /* ---------- NEW: Drawer merge after switching to subscription ---------- */
  var drawerIndex = -1;
  var drawerTimer = null;

  function markDrawer(e) {
    var item = e.target.closest('.rebuy-cart__flyout-item-subscription') &&
      e.target.closest('.rebuy-cart__flyout-item');
    if (!item) return;

    drawerIndex = [].indexOf.call(
      document.querySelectorAll('.rebuy-cart__flyout-item'), item
    );

    clearTimeout(drawerTimer);
    drawerTimer = setTimeout(mergeDrawer, 1500); // works even if Rebuy event doesn't fire
  }

  document.addEventListener('click', markDrawer, true);
  document.addEventListener('change', markDrawer, true);

  ['rebuy:cart:change', 'rebuy:cart.change'].forEach(function (name) {
    document.addEventListener(name, function () {
      if (drawerIndex < 0) return;
      clearTimeout(drawerTimer);
      drawerTimer = setTimeout(mergeDrawer, 300);
    });
  });

  async function mergeDrawer() {
    if (drawerIndex < 0 || running) return;
    var index = drawerIndex;
    drawerIndex = -1;

    var item = document.querySelectorAll('.rebuy-cart__flyout-item')[index];
    var select = item && item.querySelector('.rebuy-cart__flyout-item-subscription select');
    var chosen = select && /^\d+$/.test(select.value) ? select.value : '';

    running = true;
    var merged = false;

    try {
      var cart = await getCart();
      var ids = {};

      cart.items.forEach(function (i) {
        if (i.selling_plan_allocation) ids[i.variant_id] = 1;
      });

      for (var id in ids) {
        var matches = getMatches(cart, { variantId: String(id) });
        if (matches.length < 2) continue;

        var plans = matches.map(function (m) { return m.sellingPlanId; });

        // Keep the interval just chosen; otherwise merge only if all intervals are the same
        var keep = plans.indexOf(chosen) > -1
          ? chosen
          : plans.every(function (p) { return p === plans[0]; }) ? plans[0] : '';

        if (keep && await mergeItems(matches, { variantId: String(id), sellingPlanId: keep })) {
          merged = true;
        }
      }

      if (merged) refreshCart();
    } catch (err) {
    } finally {
      running = false;
      if (merged) setTimeout(hideLoader, 900);
    }
  }
  /* ---------- END NEW ---------- */
})();

(function () {
  var message = 'SAVE 20% ON 1ST ORDER';
  var widget = document.querySelector('.sealsubs-target-element');

  if (!widget) return;

  function update() {
    widget
      .querySelectorAll('.sls-savings-badge:empty')
      .forEach(function (badge) {
        badge.textContent = message;
        badge.classList.add('hp-custom-badge');
      });
  }

  update();

  new MutationObserver(update).observe(widget, {
    childList: true,
    subtree: true
  });
})();



/*
  Autoship + Read More Script
  Same logic as old code
  Only optimized MutationObserver so Rebuy drawer load 
*/

(() => {
  if (!document.body.classList.contains("product-page")) return;

  let s = '<span class="autoship-btn-icon" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="m4.019 20.82 2.006-2.58c2.82 2.178 8.759 5.278 14.531-1.125.469-.52.931-1.1 1.386-1.755.019-.027.039-.05.058-.078l-.012.006c-1.918 1.103-4.252 1.691-6.742 1.535-2.947-.185-4.224-.89-6.057-2.65l2.037-2.618S6.954 9.683 2 11.822l2.019 8.998Z" fill="var(--chirp-logos-as-secondary,#F27123)"></path><path fill-rule="evenodd" clip-rule="evenodd" d="m19.981 4.117-2.006 2.579c-2.82-2.178-8.76-5.278-14.531 1.125-.47.52-.932 1.101-1.386 1.756-.02.027-.039.05-.058.078l.012-.007c1.917-1.102 4.252-1.69 6.741-1.534 2.947.184 4.225.89 6.057 2.649l-2.036 2.618s4.272 1.872 9.226-.267L19.98 4.117Z" fill="var(--chirp-logos-as-primary,#031657)"></path></svg></span>';

  let autoshipTimer;

  function scheduleUpdate(delay = 300) {
    clearTimeout(autoshipTimer);
    autoshipTimer = setTimeout(e, delay);
  }

 function e(forcedAutoship) {
    let e = [...document.querySelectorAll(".btn.add-to-cart")]
      .find(e => !e.closest(".nm-portal"));

    if (!e) return;

    let t = document.querySelector(".nm-portal"),
        n = document.querySelector("#quantity-add-to-cart-container"),
        i = e.closest(".add-to-cart-button"),
        o = t && t.querySelector("button"),
        r = e.textContent.toLowerCase(),
        a =(r.includes("sold out") || r.includes("out of stock")) &&(e.disabled || e.hasAttribute("disabled") || e.classList.contains("disabled"));

    n && (n.style.display = "flex", n.style.alignItems = "center");
    i && (i.style.marginLeft = "auto", i.style.width = "60%");

    if (a) {
      e.style.display = "none";
      e.classList.remove("autoship-btn");

      t && (t.style.display = "block", t.style.width = "100%");

      o && (
        o.style.width = "100%",
        o.style.justifyContent = "center",
        o.style.display = "flex",
        o.style.alignItems = "center"
      );

      return;
    }

        /* In-stock variant */
      e.style.display = "";
      t && (t.style.display = "");

      /* Hide only the Notify me button */
      o && (o.style.display = "none");

    // IMPORTANT: Same condition as your old code
let l =
  typeof forcedAutoship === "boolean"
    ? forcedAutoship
    : !!document.querySelector(
        '.sls-option-container.sls-active[data-selling-plan-group]'
      );

    e.classList.toggle("autoship-btn", l);

    if (l) {
      if (!e.querySelector(".autoship-btn-icon") || !e.textContent.toLowerCase().includes("autoship")) {
        e.innerHTML = s + " Set Up Autoship &amp; Save";
      }
    } else {
      if (e.querySelector(".autoship-btn-icon")) {
        e.textContent = "Add to Cart";
      }
      e.classList.remove("autoship-btn");
    }
  }

  e();

  document.addEventListener("DOMContentLoaded", e);
document.addEventListener("click", function (event) {
  const sealOption = event.target.closest(".sls-option-container");

  if (sealOption) {
    const isAutoship = sealOption.hasAttribute(
      "data-selling-plan-group"
    );

    // Change the button immediately
    e(isAutoship);

    // Verify after Seal updates its active selection
    scheduleUpdate(80);
    return;
  }

  if (
    event.target.closest(
      '.product-options, ' +
      '.variant-selects, ' +
      '.swatch'
    )
  ) {
    scheduleUpdate(0);
  }
});

document.addEventListener("change", function (event) {
  if (
    event.target.closest(
      '.sls-purchase-options-container, ' +
      'form[action*="/cart/add"]'
    )
  ) {
    scheduleUpdate(80);
  }
});

  /*
    Optimized observer:
    Old code watched full document.body including Rebuy cart.
    This watches product area only.
  */
const sealWidget = document.querySelector(".sealsubs-target-element");

if (sealWidget && !sealWidget.querySelector(".sls-option-container")) {
  const sealObserver = new MutationObserver(function () {
    if (sealWidget.querySelector(".sls-option-container")) {
      sealObserver.disconnect();
      scheduleUpdate(0);
    }
  });

  sealObserver.observe(sealWidget, {
    childList: true,
    subtree: true
  });
}

  let t = document.querySelector(".tab-body-id-template--19184439296161__description");

  if (!t || t.dataset.readmoreInitialized) {
    return;
  }

  let o = 550;
  if (t.scrollHeight <= o) {
    return;
  }

  t.dataset.readmoreInitialized = "true";
  t.classList.add("hp-readmore-collapsed");

  let n = document.createElement("button");

  function i() {
    n.style.display = t.classList.contains("hide") ? "none" : "block";
  }

  n.type = "button";
  n.className = "hp-readmore-link";
  n.textContent = "See More +";

  t.insertAdjacentElement("afterend", n);
  i();

  new MutationObserver(i).observe(t, {
    attributes: true,
    attributeFilter: ["class"]
  });

  n.addEventListener("click", () => {
    t.classList.toggle("hp-readmore-collapsed");
    n.textContent = t.classList.contains("hp-readmore-collapsed")
      ? "See More +"
      : "See Less −";
  });

})();

// Dynamically updates Autoship badges and first-order discounted prices from Seal subscription rules.
// Hides the global 20% / $40 rule whenever a more specific subscription rule exists for the product.
// Prevents price/label flicker during subscription, delivery interval, and currency changes.

(function () {
  'use strict';

  const CONFIG = {
    widget: '.sealsubs-target-element',
    subscriptionRow: '.sls-option-container[data-selling-plan-group-id]',
    description: '.sls-selling-plan-description-content',
    oneTimePrice: '.sls-one-time-price .money',
    subscriptionPrice: '.sls-selling-plan-group-price .sls-price .money',
    badge: '.sls-savings-badge.hp-custom-badge',
    label: '.sls-selling-plan-group-name',
    globalPercentage: 25,
    globalCap: 40
  };

  let observer = null;
  let frameId = null;
  let processing = false;

  function parseMoney(text) {
    if (!text) return NaN;

    let value = String(text)
      .replace(/[^\d.,-]/g, '')
      .trim();

    if (!value) return NaN;

    const comma = value.lastIndexOf(',');
    const dot = value.lastIndexOf('.');

    if (comma > -1 && dot > -1) {
      value =
        comma > dot
          ? value.replace(/\./g, '').replace(',', '.')
          : value.replace(/,/g, '');
    } else if (comma > -1) {
      const decimals = value.length - comma - 1;

      value =
        decimals === 2
          ? value.replace(',', '.')
          : value.replace(/,/g, '');
    } else {
      value = value.replace(/,/g, '');
    }

    return Number(value);
  }

  function getCurrencyRate() {
    const rate = Number(
      window.Shopify?.currency?.rate || 1
    );

    return Number.isFinite(rate) && rate > 0
      ? rate
      : 1;
  }

  function getCurrencyCode() {
    return (
      window.Shopify?.currency?.active ||
      'USD'
    );
  }

  function formatMoney(amount) {
    if (!Number.isFinite(amount)) return '';

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: getCurrencyCode(),
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch {
      return amount.toFixed(2);
    }
  }

  function readRule(text) {
    if (!text) return null;

    const percentMatch = text.match(
      /Enjoy\s+([\d.]+)%\s+off/i
    );

    if (!percentMatch) return null;

    const percentage = Number(percentMatch[1]);

    if (
      !Number.isFinite(percentage) ||
      percentage <= 0 ||
      percentage > 100
    ) {
      return null;
    }

    const capMatch = text.match(
      /Up\s+to\s+[$€£₹]?\s*([\d,.]+)/i
    );

    const cap = capMatch
      ? parseMoney(capMatch[1])
      : null;

    return {
      percentage,
      cap: Number.isFinite(cap) ? cap : null
    };
  }

  function isGlobalRule(rule) {
    return Boolean(
      rule &&
      rule.percentage === CONFIG.globalPercentage &&
      rule.cap === CONFIG.globalCap
    );
  }

  function getBadge(row) {
    let badge = row.querySelector(CONFIG.badge);

    if (badge) return badge;

    const label = row.querySelector(CONFIG.label);

    if (!label) return null;

    badge = document.createElement('span');
    badge.className =
      'sls-savings-badge hp-custom-badge';

    label.append(' ', badge);

    return badge;
  }

  function setVisible(row, visible) {
    if (visible) {
      row.hidden = false;
      row.classList.remove(
        'hp-hide-subscription-rule'
      );
      row.style.removeProperty('display');
      return;
    }

    row.hidden = true;
    row.classList.add(
      'hp-hide-subscription-rule'
    );
    row.style.setProperty(
      'display',
      'none',
      'important'
    );
  }

  function updateRow(
    row,
    rule,
    regularPrice,
    currencyRate
  ) {
    const localCap =
      rule.cap !== null
        ? rule.cap * currencyRate
        : null;

    const percentageDiscount =
      regularPrice * (rule.percentage / 100);

    const discount =
      localCap !== null
        ? Math.min(
            percentageDiscount,
            localCap,
            regularPrice
          )
        : Math.min(
            percentageDiscount,
            regularPrice
          );

    const finalPrice =
      Math.max(regularPrice - discount, 0);

    const badge = getBadge(row);
  
    if (badge) {
    let text = `SAVE ${rule.percentage}% ON 1ST ORDER`;

const isTwentyFivePercentFortyCap =
  rule.percentage === 25 &&
  rule.cap === 40;

if (localCap !== null && !isTwentyFivePercentFortyCap) {
  text += ` (UP TO ${formatMoney(localCap)})`;
}

if (badge.textContent.trim() !== text) {
  badge.textContent = text;
}

      badge.style.setProperty(
        'display',
        'inline-block',
        'important'
      );
    }

    const priceEl = row.querySelector(
      CONFIG.subscriptionPrice
    );

    if (priceEl) {
      const price = formatMoney(finalPrice);

      if (priceEl.textContent.trim() !== price) {
        priceEl.textContent = price;
      }
    }
  }

  function updateWidget(widget) {
    if (!widget || processing) return;

    processing = true;
    observer?.disconnect();

    try {
      const rows = Array.from(
        widget.querySelectorAll(
          CONFIG.subscriptionRow
        )
      );

      if (!rows.length) return;

      const rules = rows.map(row => {
        const description = row.querySelector(
          CONFIG.description
        );

        const rule = readRule(
          description?.textContent || ''
        );

        return {
          row,
          rule,
          global: isGlobalRule(rule)
        };
      });

      const hasSpecificRule = rules.some(
        item =>
          item.rule &&
          !item.global
      );

      const visibleRows = [];

      rules.forEach(item => {
        const visible =
          !(item.global && hasSpecificRule);

        setVisible(item.row, visible);

        if (visible && item.rule) {
          visibleRows.push(item);
        }
      });

      const oneTimeEl = widget.querySelector(
        CONFIG.oneTimePrice
      );

      const regularPrice = parseMoney(
        oneTimeEl?.textContent
      );

      if (
        !Number.isFinite(regularPrice) ||
        regularPrice <= 0
      ) {
        return;
      }

      const currencyRate = getCurrencyRate();

      visibleRows.forEach(item => {
        updateRow(
          item.row,
          item.rule,
          regularPrice,
          currencyRate
        );
      });

      const hiddenActive = rules.find(item => {
        if (
          !item.row.classList.contains(
            'hp-hide-subscription-rule'
          )
        ) {
          return false;
        }

        return (
          item.row.classList.contains(
            'sls-active'
          ) ||
          item.row.querySelector(
            '[role="radio"][aria-checked="true"]'
          )
        );
      });

      if (
        hiddenActive &&
        visibleRows.length
      ) {
        const radio =
          visibleRows[0].row.querySelector(
            '[role="radio"]'
          );

        radio?.click();
      }
    } finally {
      widget.classList.remove(
        'hp-seal-syncing'
      );

      processing = false;

      observer?.observe(widget, {
        childList: true,
        subtree: true
      });
    }
  }

  function schedule(widget) {
    if (frameId !== null) {
      cancelAnimationFrame(frameId);
    }

    frameId = requestAnimationFrame(() => {
      frameId = null;
      updateWidget(widget);
    });
  }

  function init() {
    const widget = document.querySelector(
      CONFIG.widget
    );

    if (!widget) return false;

    observer = new MutationObserver(() => {
      if (processing) return;

      widget.classList.add(
        'hp-seal-syncing'
      );

      schedule(widget);
    });

    observer.observe(widget, {
      childList: true,
      subtree: true
    });

    widget.addEventListener(
      'pointerdown',
      event => {
        if (
          event.target.closest(
            '.sls-option-container'
          )
        ) {
          widget.classList.add(
            'hp-seal-syncing'
          );
        }
      },
      true
    );

    widget.addEventListener(
      'change',
      () => {
        widget.classList.add(
          'hp-seal-syncing'
        );

        schedule(widget);
      },
      true
    );

    updateWidget(widget);

    setTimeout(
      () => schedule(widget),
      800
    );

    [
      'currency:changed',
      'currencyChanged',
      'shopify:currency:changed'
    ].forEach(eventName => {
      document.addEventListener(
        eventName,
        () => {
          widget.classList.add(
            'hp-seal-syncing'
          );

          schedule(widget);
        }
      );
    });

    return true;
  }

  function start() {
    if (init()) return;

    let attempts = 0;

    const loader = setInterval(() => {
      attempts += 1;

      if (
        init() ||
        attempts >= 20
      ) {
        clearInterval(loader);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();


// (function () {
//   const target = document.querySelector('.sealsubs-target-element');
//   if (!target) return;

//   function updateAutoshipPrice() {
//     const oneTimeEl = target.querySelector('.sls-one-time-price .money');
//     const autoshipEl = target.querySelector('.sls-selling-plan-group-price .money');

//     if (!oneTimeEl || !autoshipEl) return;

//     const price = parseFloat(
//       oneTimeEl.textContent.replace(/[^0-9.,]/g, '').replace(/,/g, '')
//     );

//     if (!price) return;

//     /* Shopify currency conversion rate */
//     const rate =
//       window.Shopify &&
//       Shopify.currency &&
//       Shopify.currency.rate
//         ? Number(Shopify.currency.rate)
//         : 1;

//     /* $40 USD cap converted to customer's currency */
//     const localCap = 40 * rate;

//     const discount = Math.min(price * 0.20, localCap);
//     const finalPrice = price - discount;

//     /* Keep the same currency symbol */
//     const symbol = oneTimeEl.textContent
//       .trim()
//       .replace(/[0-9.,\s]/g, '');

//     const output = symbol + finalPrice.toFixed(2);

//     if (autoshipEl.textContent.trim() !== output) {
//       autoshipEl.textContent = output;
//     }
//   }

//   updateAutoshipPrice();

//   new MutationObserver(updateAutoshipPrice).observe(target, {
//     childList: true,
//     subtree: true,
//     characterData: true
//   });
// })();


(function () {
  const selector = '.sls-selling-plan-description-content';

  function formatDescription(el) {
    if (!el || el.querySelector('.hp-autoship-benefits')) {
      return;
    }

    const text = el.textContent.trim();

    if (!text) {
      return;
    }

    const items = text
      .split(/\.\s+/)
      .map(text => text.replace(/\.$/, '').trim())
      .filter(Boolean);

    if (!items.length) {
      return;
    }

    const list = document.createElement('ul');
    list.className = 'hp-autoship-benefits';

    items.forEach((text, index) => {
      const item = document.createElement('li');

      item.className =
        'hp-autoship-item' +
        (
          index === items.length - 1
            ? ' hp-autoship-item-last'
            : ''
        );

      item.textContent = text + '.';

      list.appendChild(item);
    });

    el.replaceChildren(list);
  }

  function formatAll() {
    document
      .querySelectorAll(selector)
      .forEach(formatDescription);
  }

  formatAll();

  const seal = document.querySelector(
    '.sealsubs-target-element'
  );

  if (!seal) {
    return;
  }

  let frameId = null;

  const observer = new MutationObserver(() => {
    if (frameId !== null) {
      cancelAnimationFrame(frameId);
    }

    frameId = requestAnimationFrame(() => {
      frameId = null;
      formatAll();
    });
  });

  observer.observe(seal, {
    childList: true,
    subtree: true
  });
})();

(() => {
  let y, timer, active = false;

  const fixScroll = () => {
    if (active && Math.abs(scrollY - y) > 1) {
      scrollTo(0, y);
    }
  };

  document.addEventListener('pointerdown', e => {
    if (!e.target.closest('.swatch-element.soldout')) return;

    y = scrollY;
    active = true;

    document.documentElement.classList.add('hp-soldout-variant-changing');
    window.addEventListener('scroll', fixScroll, { passive: true });

    requestAnimationFrame(() => {
      fixScroll();
      requestAnimationFrame(fixScroll);
    });

    clearTimeout(timer);
    timer = setTimeout(() => {
      fixScroll();
      active = false;
      window.removeEventListener('scroll', fixScroll);
      document.documentElement.classList.remove(
        'hp-soldout-variant-changing'
      );
    }, 500);
  }, true);
})();